module.exports = __webpack_public_path__ + "static/media/65.f346d212.jpg";